import { SxProps } from '@mui/material';

export const styledGridSx: SxProps = {
	padding: '5px 0 5px 5px',
	minHeight: '100% !important',
};
